// extracted by mini-css-extract-plugin
export default {"chatItem":"ChatItem_chatItem__swsxj","info":"ChatItem_info__twwNM","header":"ChatItem_header__5nrTR","active":"ChatItem_active__MDL2R","message":"ChatItem_message__RAp4n"};